// app.component.ts
import { Component, OnInit, OnDestroy } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'civ-po';
  private readonly destroyed$ = new Subject<void>();

  constructor(
    private readonly msal: MsalService,
    private readonly msalBroadcast: MsalBroadcastService
  ) {}

  ngOnInit(): void {
    this.msalBroadcast.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => {
        this.checkAndSetActiveAccount();
      });
    this.checkAndSetActiveAccount();
  }

  checkAndSetActiveAccount() {
    const accounts = this.msal.instance.getAllAccounts();
    if (accounts.length > 0) {
      const active = this.msal.instance.getActiveAccount();
      if (!active) {
        this.msal.instance.setActiveAccount(accounts[0]);
      }
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
